"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var VerticalDivider_classNames_1 = require("./VerticalDivider.classNames");
var Styling_1 = require("../../Styling");
exports.VerticalDivider = function (props) {
    var theme = Styling_1.getTheme();
    var classNames = props.getClassNames ? props.getClassNames(theme) : VerticalDivider_classNames_1.getDividerClassNames(theme);
    return (React.createElement("span", { className: classNames.wrapper },
        React.createElement("span", { className: classNames.divider })));
};
//# sourceMappingURL=VerticalDivider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Divider/VerticalDivider.js
// module id = 1523
// module chunks = 0